import { Navigate, Route, Routes } from 'react-router-dom';
import { AccountPage } from './pages/AccountPage';
import { ComparePage } from './pages/ComparePage';
import { BrowsePage } from './pages/BrowsePage';
import { ExplorePage } from './pages/ExplorePage';
import { JourneyDetailPage } from './pages/JourneyDetailPage';
import { JourneysPage } from './pages/JourneysPage';
import { LandingPage } from './pages/LandingPage';
import { ModulePage } from './pages/ModulePage';
import { SearchPage } from './pages/SearchPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { NotFoundPage } from './pages/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/study" element={<AccountPage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/browse" element={<BrowsePage />} />
      <Route path="/journeys" element={<JourneysPage />} />
      <Route path="/journeys/:slug" element={<JourneyDetailPage />} />
      <Route path="/questions" element={<Navigate to="/journeys" replace />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/m/:slug" element={<ModulePage />} />
      <Route path="/home" element={<Navigate to="/study" replace />} />
      <Route path="/account" element={<Navigate to="/study" replace />} />
      <Route path="/onboarding" element={<Navigate to="/study" replace />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/compare" element={<Navigate to="/compare/islam-christianity-jesus" replace />} />
      <Route path="/compare/:slug" element={<ComparePage />} />
      <Route path="/foundations" element={<Navigate to="/explore" replace />} />
      <Route path="/difficult" element={<Navigate to="/journeys/difficult-questions-about-islam" replace />} />
      <Route path="/for-muslims" element={<Navigate to="/journeys" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
